export default "__VITE_ASSET__1767fed3__"